import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchMediaForPalette } from "actions/palette";

import _ from "lodash";
import cx from "classnames";
import { Button, Nav, Tab } from "react-bootstrap";

import InfiniteScroll from "components/InfiniteScroll";
import { Media, Video, EmptyMessage } from "components/MediaLibrary/MediaPalette";

import styles from "./brandMediaPalette.module.scss";

export const BrandMediaPaletteView = ({ storyboard, palette, mediaTypes = ['image', 'video'], multiple, handleMediaLibrary, onSelect }) => {
  const [state, setState] = useState({
    active: 'image',
    selected: []
  })

  const handleTabChange = (active) => {
    setState(state => {
      return {
        ...state,
        active: active
      }
    })
  }

  const handleClick = (media) => {
    var updated = [...state.selected];

    media = {
      ...media,
      brandkitMedia: true
    }

    if (multiple) {
      const exists = updated.find(m => m.id === media.id) != null;
      if (exists) {
        updated = updated.filter(m => m.id !== media.id);
      } else {
        updated = [...updated, media];
      }
    } else {
      updated = [media];
    }

    setState(state => {
      return {
        ...state,
        selected: updated
      }
    })
  }

  const renderTabsIcon = (icon, title) => {
    return (
      <div className={styles.tabsButton}>
        <i className={`cleverstory-${icon}`} />
        <span className={styles.tabsTitle}>{title}</span>
      </div>
    )
  }

  if(!palette) {
    return null;
  }

  return (
    <div className={styles.mediaPalette}>
      <Tab.Container id="left-tabs-example" defaultActiveKey="image" onSelect={handleTabChange}>
        <div className={cx(styles.palatteHeader, 'handle')}>
          <Nav className={styles.navigationTabs}>
            <Nav.Item>
              <Nav.Link active={state.active === 'image'} eventKey="image">{renderTabsIcon('background', 'images')}</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link active={state.active === 'video'} eventKey="video">{renderTabsIcon('video', 'videos')}</Nav.Link>
            </Nav.Item>
          </Nav>
        </div>
        <div className={styles.tabContentView}>
          <Tab.Content>
            {state.active === 'image' &&
              <MediaGrid
                storyboard={storyboard} 
                palette={palette}
                onSelect={handleClick}
                mediaType='image' 
                handleMediaLibrary={handleMediaLibrary}
                selected={state.selected}
              />
            }
            {state.active === 'video' &&
              <MediaGrid 
                storyboard={storyboard}
                palette={palette}
                onSelect={handleClick}
                mediaType='video' 
                handleMediaLibrary={handleMediaLibrary}
                selected={state.selected}
              />
            }
          </Tab.Content>
        </div>
      </Tab.Container>
      <div className={styles.actionContainer}>
        <Button variant="primary" disabled={_.size(state.selected) === 0}
          onClick={() => {
            onSelect(state.selected);
          }}
          className={styles.actionButton}>
          Choose Media
        </Button>
      </div>
    </div>
  )
}

export const MediaGrid = ({ storyboard, palette, onSelect, mediaType, handleMediaLibrary, selected }) => {
  const dispatch = useDispatch();

  const mediaList = useSelector(state => { return _.get(state, `palette.brandkit[${palette}][${mediaType}].items`) || [] });
  const loading = useSelector(state => { return _.get(state, `palette.brandkit[${palette}][${mediaType}].loading`) });
  const fetched = useSelector(state => { return _.get(state, `palette.brandkit[${palette}][${mediaType}].fetched`) });
  const pagination = useSelector(state => { return _.get(state, `palette.brandkit[${palette}][${mediaType}].pagination`) });
  const hasMoreItems = _.get(pagination, 'currentPage') < _.get(pagination, 'totalPages') - 1;

  useEffect(() => {
    if (!fetched) {
      handleFetchMediaForPalette(0);
    }
  }, [mediaType]);

  const handleFetchMediaForPalette = (page) => {
    const request = {
      palette: palette,
      mediaTypes: [mediaType],
      page: page,
      limit: 20,
      sort: 'modifiedDate',
      order: 'desc'
    };

    dispatch(fetchMediaForPalette(palette, 'brandkit', mediaType, request));
  }

  const openMediaLibrary = (e) => {
    e.stopPropagation()
    handleMediaLibrary()
  }

  const loadMore = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }
    handleFetchMediaForPalette(nextPage);
  }

  if (fetched && mediaList.length === 0) {
    return (
      <EmptyMessage storyboard={storyboard} target={palette} mediaTypes={[mediaType]} openMediaLibrary={openMediaLibrary} disabled={true}/>
    )
  }


  return (
    <InfiniteScroll
      className={cx(styles.scrollable)}
      loading={loading}
      hasMore={hasMoreItems}
      loadMore={loadMore}
    >
      <Tab.Pane eventKey="image">
        {mediaList.map(media => {
          let active = selected.some(data => data.id === media.id);

          if (mediaType === 'image') {
            return (
              <Media key={media.id}
                media={media}
                selected={active}
                onClick={() => {
                  onSelect(media);
                }}
              />
            )
          }

          if (mediaType === 'video') {
            return (
              <Video key={media.id}
                muted
                media={media}
                selected={active}
                onClick={() => {
                  onSelect(media);
                }}
              />
            )
          }

          return null;
        })}
      </Tab.Pane>
    </InfiniteScroll>
  )
}
